import Image from 'next/image';
import { FormattedMessage } from 'react-intl';

import GoogleIcon from '@/public/images/icons/google-icon.svg';

import style from './home.module.scss';

const OverallRating = (props: any) => {
  return (
    <div className="overall-ratings">
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
          <div className="d-flex align-items-center justify-content-center">
            <div>
              <p className={style.overallratings}>
                <FormattedMessage id="rated-reviews" />
                &nbsp;<b>{props?.rating}</b>&nbsp;
                <FormattedMessage id="out-of" />
                &nbsp;
                <b>
                  {' '}
                  {props?.numberOfReviews}&nbsp;
                  <FormattedMessage id="reviews-of" />
                </b>
                &nbsp;
                <FormattedMessage id="reviews-on" />{' '}
              </p>
            </div>
            <div>
              <Image src={GoogleIcon} alt="google" height="30px" width="30px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallRating;
